'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbScrollToTop = fbScrollToTop;
/*
    Scroll to top
    -------------------------------- 
*/

function fbScrollToTop() {
    return {
        restrict: 'A',
        controller: ["$element", "$anchorScroll", function controller($element, $anchorScroll) {
            'ngInject';

            $element.on('click', function (e) {
                e.preventDefault();
                $anchorScroll(0);
            });

            // https://github.com/oblador/angular-scroll
        }]
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/directives/fb-scroll-to-top.js
// module id = 721
// module chunks = 0